import { Gender, ProgramType } from 'fitbeat.models';

export const BodymetricRateOfChangeConfig: { [type in ProgramType]: number } = {
    [ProgramType.GetLeanAndFitGoal]: -1.8,
    [ProgramType.GainMuscleAndStrengthGoal]: 0.75,
    [ProgramType.GetStrongAndFitGoal]: -1,
    [ProgramType.MobilityAndTone]: -1,
    [ProgramType.MuscleAndShred]: -1.8,
    [ProgramType.NotSet]: 0,
};

export const BMIMinMax: { [type in Gender]: { min: number, max: number } } = {
    [Gender.Male]: { min: 18, max: 24.9 },
    [Gender.Female]: { min: 18, max: 24.9 },
    [Gender.Other]: { min: 18, max: 24.9 },
};
